.atm_5j_gktfv{border-radius:20px;}
.atm_lk_1vi7ecw.atm_lk_1vi7ecw{padding-left:32px;}
.atm_mj_glywfm{pointer-events:none;}
.atm_mk_stnw88{position:absolute;}
.atm_tk_1ssbidh{top:50%;}
.atm_fq_exct8b{left:16px;}
.atm_uc_8zhzcj{transition:color 200ms ease-out,left 250ms ease-out,transform 250ms ease-out;}
.atm_tr_9kiium{transform:translate(0%, -50%);}
.atm_fq_1ssbidh{left:50%;}
.atm_tr_1ooetej{transform:translate(-50%, -50%);}
.atm_l8_1y44olf{padding:4px;}
.atm_vy_1tcgj5g{width:24px;}
.atm_jb_1tcgj5g{min-width:24px;}
.atm_e2_1tcgj5g{height:24px;}
